
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

//components
import {ModalHeader, ModalContent, ModalFooter,ContentItem,Dropdown} from '@gnb/components/Common'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'

// types
import * as accountTypes from '@account/store/types'

import api from '@gnb/api';


@Component({
    components:{
        ModalHeader,
        ModalContent,
        ModalFooter,
        ContentItem,
        PreferenceContentTemplate,
        Dropdown
    },
    computed: {
        ...mapGetters({
            user: accountTypes.USER
        })
    }
})
export default class ChangeApprovalPWView extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    placeholder:string = this.$t('비밀번호를_입력해_주세요').toString();
    name:string = this.$t('결재_비밀번호').toString();

    isApprovalPassword: boolean = false; // 결재 비밀번호 사용 여부
    nowPassword: string = ''; // 기존 비밀번호
    inputPassword: string = ''; // 입력한 비밀번호
    reInputPassword: string = ''; // 2번째 입력한 비밀번호

    isPasswordChanged: boolean = false; // 비밀번호 변경 여부

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object }) settingInfo!: gnb.TA_MYSETTING;
    @Prop({ type: String, default: 'workflow' }) WorkflowPWCheckType!: string;
    
    // ─── Getters ─────────────────────────────────────────────────────────

    user!: account.User;

    // ─── Computed ────────────────────────────────────────────────────────

    

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    /**
     * 기존비밀번호 입력시 호출됩니다.
     * @param value 
     */
    setNowPassword(value: string){
        this.nowPassword = value;
    }

    /**
     * 비밀번호 입력시 호출됩니다.
     * @param value 
     */
    setPassword(value: string){
        this.isPasswordChanged = true;
        this.inputPassword = value;
        // if(this.WorkflowPWCheckType == 'workflow'){
        //     this.settingInfo.password = value;
        // }
    }

    /**
     * 비밀번호 재 입력시 호출됩니다.
     * @param value 
     */
    setPassword2(value: string){
        this.reInputPassword = value;
    }

    /**
     * 비밀번호 확인 버튼 클릭시 호출됩니다.
     * 개별 비밀번호 사용시, 입력된 비번이 동일한지 확인
     * AD 비밀번호 사용시, AD 비번이 맞는지 확인
     */
    async checkPW(){
        debugger;
        var result = null;
        if(this.inputPassword ==''){
            (window as any).alertAsync(this.$t('M_EmptyNewPassword').toString());
            return
        }
        else if(this.reInputPassword ==''){
            (window as any).alertAsync(this.$t('M_EmptyNewPasswordConfirm').toString());
            return
        }
        if(this.WorkflowPWCheckType == 'workflow'){
            if(this.settingInfo.password){
                result = ((this.settingInfo.password === this.nowPassword) && (this.inputPassword === this.reInputPassword));
            }
            else{
                result = this.inputPassword === this.reInputPassword;
            }
        }
        else {
            result = await api.common.getLDAPAuthenticate(this.user.personId, this.inputPassword);
        }

        if(result){
            if(this.WorkflowPWCheckType == 'workflow'){
                this.settingInfo.password = this.inputPassword;
            }

            this.isPasswordChanged = false;
            (this.$refs.pwbtn as HTMLButtonElement).setAttribute('disabled', 'true');
            this.$emit('pwChecked', true);
        }
        else{
            this.$emit('pwChecked', false);
            (window as any).alertAsync(this.$t('M_DifferentPassword').toString());
        }
    }

    @Watch('settingInfo')
    onSettingInfoChanged(newValue: gnb.TA_MYSETTING){
        this.isApprovalPassword = this.settingInfo.isApprovalPassword || false;
    }

    @Watch('isPasswordChanged')
    onIsPasswordChanged(newValue: boolean, oldValue: boolean){
        if(newValue){
            (this.$refs.pwbtn as HTMLButtonElement).removeAttribute('disabled');
            this.$emit('pwChecked', false);
        }

    }

    @Watch('isApprovalPassword')
    onIsApprovalPasswordChagned(newValue: boolean, oldValue: boolean){
        this.settingInfo.isApprovalPassword = newValue;
        if(!newValue){
            this.inputPassword = '';
            this.settingInfo.password = '';
        }
    }

}